export const getDefaultItemType = (hasMarketplacePermission: boolean) => {
  return hasMarketplacePermission
    ? `?item_types=assignment`
    : `?item_types=private_doc`
}
